/**
 * @generated SignedSource<<ec0a523f8c7977eca85deb100a2e387f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskCopilotMessageRole = "ASSISTANT" | "USER";
export type AskFellowPanelConversationsQuery$variables = {
  conversationId: string;
};
export type AskFellowPanelConversationsQuery$data = {
  readonly viewer: {
    readonly conversation: {
      readonly __typename: "AskCopilotConversation";
      readonly context: {
        readonly filters: string | null;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly messages: ReadonlyArray<{
        readonly content: string;
        readonly contentForDisplay: string | null;
        readonly contentJson: any | null;
        readonly createdAt: string;
        readonly id: string;
        readonly isResponse: boolean;
        readonly pending: boolean;
        readonly role: AskCopilotMessageRole;
        readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInner_ChatMessage_message" | "AskFellowPanelInner_ToolUseAndResult_result" | "AskFellowPanelInner_ToolUseAndResult_use" | "AskFellowPanelInner_groupToolUsesWithResponse_message">;
      }>;
      readonly note: {
        readonly id: string;
      } | null;
      readonly reachedMessageLimit: boolean;
      readonly suggestedQuestions: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion">;
      }>;
      readonly title: string;
      readonly " $fragmentSpreads": FragmentRefs<"AskFellowContext_conversation" | "AskFellowHooks_useAskCopilotSendMessage_conversation" | "AskFellowPanelInnerConversationListener_conversation" | "AskFellowPanelInner_ChatMessage_conversation" | "AskFellowSuggestedQuestions_EmptyState_conversation">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  };
};
export type AskFellowPanelConversationsQuery = {
  response: AskFellowPanelConversationsQuery$data;
  variables: AskFellowPanelConversationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "conversationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "conversationId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "role",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentJson",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pending",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isResponse",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentForDisplay",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reachedMessageLimit",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "AskCopilotConversationContext",
  "kind": "LinkedField",
  "name": "context",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filters",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AskFellowPanelConversationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "conversation",
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "note",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AskCopilotMessage",
                    "kind": "LinkedField",
                    "name": "messages",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "AskFellowPanelInner_groupToolUsesWithResponse_message",
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v11/*: any*/),
                          (v7/*: any*/)
                        ],
                        "args": null,
                        "argumentDefinitions": []
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AskFellowPanelInner_ToolUseAndResult_use"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AskFellowPanelInner_ToolUseAndResult_result"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AskFellowPanelInner_ChatMessage_message"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SuggestedQuestion",
                    "kind": "LinkedField",
                    "name": "suggestedQuestions",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion"
                      }
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AskFellowPanelInnerConversationListener_conversation"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AskFellowHooks_useAskCopilotSendMessage_conversation"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AskFellowSuggestedQuestions_EmptyState_conversation"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AskFellowPanelInner_ChatMessage_conversation"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AskFellowContext_conversation"
                  },
                  (v13/*: any*/)
                ],
                "type": "AskCopilotConversation",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AskFellowPanelConversationsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "conversation",
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "note",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AskCopilotMessage",
                    "kind": "LinkedField",
                    "name": "messages",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "userRating",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SuggestedQuestion",
                    "kind": "LinkedField",
                    "name": "suggestedQuestions",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "groupName",
                    "storageKey": null
                  },
                  (v13/*: any*/)
                ],
                "type": "AskCopilotConversation",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a5fe95cafed68432046bd0caff0d6ec3",
    "id": null,
    "metadata": {},
    "name": "AskFellowPanelConversationsQuery",
    "operationKind": "query",
    "text": "query AskFellowPanelConversationsQuery(\n  $conversationId: ID!\n) {\n  viewer {\n    conversation: node(id: $conversationId) {\n      __typename\n      ... on AskCopilotConversation {\n        note {\n          __typename\n          id\n        }\n        id\n        title\n        messages {\n          id\n          role\n          content\n          contentJson\n          pending\n          createdAt\n          isResponse\n          contentForDisplay\n          ...AskFellowPanelInner_groupToolUsesWithResponse_message\n          ...AskFellowPanelInner_ToolUseAndResult_use\n          ...AskFellowPanelInner_ToolUseAndResult_result\n          ...AskFellowPanelInner_ChatMessage_message\n        }\n        suggestedQuestions {\n          id\n          ...AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion\n        }\n        reachedMessageLimit\n        ...AskFellowPanelInnerConversationListener_conversation\n        ...AskFellowHooks_useAskCopilotSendMessage_conversation\n        ...AskFellowSuggestedQuestions_EmptyState_conversation\n        ...AskFellowPanelInner_ChatMessage_conversation\n        ...AskFellowContext_conversation\n        context {\n          name\n          filters\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment AskFellowContext_conversation on AskCopilotConversation {\n  id\n  context {\n    name\n    filters\n  }\n}\n\nfragment AskFellowHooks_useAskCopilotSendMessage_conversation on AskCopilotConversation {\n  id\n  context {\n    name\n  }\n}\n\nfragment AskFellowPanelInnerConversationListener_conversation on AskCopilotConversation {\n  id\n  groupName\n}\n\nfragment AskFellowPanelInner_ChatMessage_conversation on AskCopilotConversation {\n  note {\n    id\n    __typename\n  }\n}\n\nfragment AskFellowPanelInner_ChatMessage_message on AskCopilotMessage {\n  id\n  role\n  content\n  contentJson\n  contentForDisplay\n  pending\n  isResponse\n  ...AskFellowPanelInner_ToolUseAndResult_use\n  ...AskFellowPanelInner_RatingButtons_message\n}\n\nfragment AskFellowPanelInner_RatingButtons_message on AskCopilotMessage {\n  id\n  userRating\n}\n\nfragment AskFellowPanelInner_ToolUseAndResult_result on AskCopilotMessage {\n  contentJson\n}\n\nfragment AskFellowPanelInner_ToolUseAndResult_use on AskCopilotMessage {\n  contentJson\n}\n\nfragment AskFellowPanelInner_groupToolUsesWithResponse_message on AskCopilotMessage {\n  id\n  role\n  content\n  contentForDisplay\n  contentJson\n}\n\nfragment AskFellowSuggestedQuestions_EmptyState_conversation on AskCopilotConversation {\n  suggestedQuestions {\n    id\n    ...AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion\n  }\n  context {\n    name\n    filters\n  }\n}\n\nfragment AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion on SuggestedQuestion {\n  id\n  content\n  contentForDisplay\n}\n"
  }
};
})();

(node as any).hash = "659e74f46f0eb48b430689e372b7f4ae";

export default node;
